// Auto-generated from translation.csv; do not edit manually
import { zhCN } from './zh-CN';
import { zhTW } from './zh-TW';
import { enUS } from './en-US';
import { jaJP } from './ja-JP';
import { koKR } from './ko-KR';
import { ruRU } from './ru-RU';
import { viVN } from './vi-VN';
import { deDE } from './de-DE';
import { ptPT } from './pt-PT';
import { esES } from './es-ES';
import { frFR } from './fr-FR';

export type GeneratedLocale = 'zh-CN' | 'zh-TW' | 'en-US' | 'ja-JP' | 'ko-KR' | 'ru-RU' | 'vi-VN' | 'de-DE' | 'pt-PT' | 'es-ES' | 'fr-FR';

export const generatedTranslations = {
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  'en-US': enUS,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'ru-RU': ruRU,
  'vi-VN': viVN,
  'de-DE': deDE,
  'pt-PT': ptPT,
  'es-ES': esES,
  'fr-FR': frFR,
} as const;
